import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderAppendInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedReq: HttpRequest<any>;
    const token = localStorage.getItem('token');
    // Backend expects ISO 639-1 language code e.g. en, fr, de
    const language = localStorage.getItem('language') || 'en';

    clonedReq = req.clone({ setHeaders: { 'Anessa-Origin': 'ADA' } });
    // TODO: This can be removed when language is pulled from browser language instead of buttons
    // TODO: Browser autofills accept language with the user's chosen language
    clonedReq = clonedReq.clone({ setHeaders: { 'Accept-Language': language } });
    if (token) {
      clonedReq = clonedReq.clone({setHeaders: { 'Authorization': `Bearer ${token}` }});
    }
    return next.handle(clonedReq);
  }
}
